import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Input, Button, Space, Tooltip } from "antd";
import axios from "../context/axiosConfig";

const { TextArea } = Input;

const CommentWithFragments = ({
	commentName,
	disabled,
	value,
	defaultValue,
	onChange,
	placeholder,
	style,
	textAreaStyle,
	...props
}) => {
	const [commentData, setCommentData] = useState([]);
	const textAreaRef = useRef(null);
	const lastSelectionRef = useRef(null);
	const currentValue = value ?? defaultValue ?? "";

	const getNativeTextArea = () => {
		const instance = textAreaRef.current;
		return (
			instance?.resizableTextArea?.textArea ||
			instance?.textArea ||
			instance ||
			null
		);
	};

	const fetchComments = async () => {
		try {
			const response = await axios.post("/settings/comments/fragments");
			setCommentData(response.data.fragments);
		} catch (error) {
			console.error("Error fetching comment fragments:", error);
		}
	};

	useEffect(() => {
		fetchComments();
	}, []);

	useLayoutEffect(() => {
		const textArea = getNativeTextArea();
		const selection = lastSelectionRef.current;
		if (!textArea || !selection) return;
		if (document.activeElement !== textArea) return;

		try {
			textArea.setSelectionRange(selection.start, selection.end);
		} catch {
			// ignore
		}
	}, [currentValue]);

	const addFragmentToComment = (fragmentText) => {
		const currentComment = currentValue || "";
		const newComment =
			currentComment + (currentComment ? "\n" : "") + fragmentText;
		onChange({ target: { value: newComment } });
	};

	const handleChange = (e) => {
		const textArea = getNativeTextArea();
		if (textArea) {
			lastSelectionRef.current = {
				start: textArea.selectionStart,
				end: textArea.selectionEnd,
			};
		}
		onChange?.(e);
	};

	return (
		<Space
			direction="vertical"
			style={{ width: "100%", ...style }}
		>
			{!disabled && (
				<Space wrap>
					{commentData
						.filter(
							(fragment) =>
								fragment.msr_comments_fragments_comment_name ===
								commentName
						)
						.map((fragment) => (
							<Tooltip
								title={fragment.msr_comments_fragments_text}
								key={fragment.msr_comments_fragments_id}
							>
								<Button
									onClick={() =>
										addFragmentToComment(
											fragment.msr_comments_fragments_text
										)
									}
								>
									{fragment.msr_comments_fragments_name}
								</Button>
							</Tooltip>
						))}
				</Space>
			)}
			<TextArea
				{...props}
				ref={textAreaRef}
				style={{ height: "6em", resize: "none", ...textAreaStyle }}
				value={currentValue}
				placeholder={placeholder}
				onChange={handleChange}
			/>
		</Space>
	);
};

export default CommentWithFragments;
